import "../../chunk-7QVYU63E.js";
import { z } from "zod";
var Network = /* @__PURE__ */ function(Network2) {
  Network2[Network2["ETH_MAINNET"] = 0] = "ETH_MAINNET";
  Network2[Network2["ETH_ROPSTEN"] = 1] = "ETH_ROPSTEN";
  Network2[Network2["ETH_RINKEBY"] = 2] = "ETH_RINKEBY";
  Network2[Network2["ETH_KOVAN"] = 3] = "ETH_KOVAN";
  Network2[Network2["ETH_GOERLI"] = 4] = "ETH_GOERLI";
  Network2[Network2["ETH_SEPOLIA"] = 5] = "ETH_SEPOLIA";
  Network2[Network2["ETH_HOLESKY"] = 6] = "ETH_HOLESKY";
  Network2[Network2["ETH_HOODI"] = 9] = "ETH_HOODI";
  Network2[Network2["FLOW_MAINNET"] = 300] = "FLOW_MAINNET";
  Network2[Network2["FLOW_TESTNET"] = 301] = "FLOW_TESTNET";
  Network2[Network2["ARB_MAINNET"] = 201] = "ARB_MAINNET";
  Network2[Network2["ARB_RINKEBY"] = 203] = "ARB_RINKEBY";
  Network2[Network2["ARB_GOERLI"] = 205] = "ARB_GOERLI";
  Network2[Network2["ARB_SEPOLIA"] = 206] = "ARB_SEPOLIA";
  Network2[Network2["MATIC_MAINNET"] = 401] = "MATIC_MAINNET";
  Network2[Network2["MATIC_MUMBAI"] = 406] = "MATIC_MUMBAI";
  Network2[Network2["MATIC_AMOY"] = 407] = "MATIC_AMOY";
  Network2[Network2["OPT_MAINNET"] = 501] = "OPT_MAINNET";
  Network2[Network2["OPT_KOVAN"] = 504] = "OPT_KOVAN";
  Network2[Network2["OPT_GOERLI"] = 505] = "OPT_GOERLI";
  Network2[Network2["OPT_SEPOLIA"] = 506] = "OPT_SEPOLIA";
  Network2[Network2["SOLANA_MAINNET"] = 701] = "SOLANA_MAINNET";
  Network2[Network2["SOLANA_DEVNET"] = 703] = "SOLANA_DEVNET";
  Network2[Network2["ASTAR_MAINNET"] = 801] = "ASTAR_MAINNET";
  Network2[Network2["POLYGONZKEVM_MAINNET"] = 901] = "POLYGONZKEVM_MAINNET";
  Network2[Network2["POLYGONZKEVM_TESTNET"] = 902] = "POLYGONZKEVM_TESTNET";
  Network2[Network2["POLYGONZKEVM_CARDONA"] = 903] = "POLYGONZKEVM_CARDONA";
  Network2[Network2["STARKNET_MAINNET"] = 1001] = "STARKNET_MAINNET";
  Network2[Network2["STARKNET_GOERLI"] = 1002] = "STARKNET_GOERLI";
  Network2[Network2["STARKNET_SEPOLIA"] = 1003] = "STARKNET_SEPOLIA";
  Network2[Network2["BASE_MAINNET"] = 1101] = "BASE_MAINNET";
  Network2[Network2["BASE_GOERLI"] = 1102] = "BASE_GOERLI";
  Network2[Network2["BASE_SEPOLIA"] = 1103] = "BASE_SEPOLIA";
  Network2[Network2["TEMPO_MAINNET"] = 1161] = "TEMPO_MAINNET";
  Network2[Network2["TEMPO_TESTNET"] = 1162] = "TEMPO_TESTNET";
  Network2[Network2["ZKSYNC_MAINNET"] = 1201] = "ZKSYNC_MAINNET";
  Network2[Network2["ZKSYNC_SEPOLIA"] = 1202] = "ZKSYNC_SEPOLIA";
  Network2[Network2["ZORA_MAINNET"] = 1301] = "ZORA_MAINNET";
  Network2[Network2["ZORA_SEPOLIA"] = 1302] = "ZORA_SEPOLIA";
  Network2[Network2["FRAX_MAINNET"] = 1401] = "FRAX_MAINNET";
  Network2[Network2["FRAX_SEPOLIA"] = 1402] = "FRAX_SEPOLIA";
  Network2[Network2["BNB_MAINNET"] = 1501] = "BNB_MAINNET";
  Network2[Network2["BNB_TESTNET"] = 1502] = "BNB_TESTNET";
  Network2[Network2["AVAX_MAINNET"] = 1601] = "AVAX_MAINNET";
  Network2[Network2["AVAX_FUJI"] = 1602] = "AVAX_FUJI";
  Network2[Network2["ARBNOVA_MAINNET"] = 1701] = "ARBNOVA_MAINNET";
  Network2[Network2["ALCHEMY_MAINNET"] = 1801] = "ALCHEMY_MAINNET";
  Network2[Network2["ALCHEMY_SEPOLIA"] = 1802] = "ALCHEMY_SEPOLIA";
  Network2[Network2["ALCHEMY_INTERNAL"] = 1803] = "ALCHEMY_INTERNAL";
  Network2[Network2["WORLDCHAIN_MAINNET"] = 1901] = "WORLDCHAIN_MAINNET";
  Network2[Network2["WORLDCHAIN_SEPOLIA"] = 1902] = "WORLDCHAIN_SEPOLIA";
  Network2[Network2["ZETACHAIN_MAINNET"] = 2001] = "ZETACHAIN_MAINNET";
  Network2[Network2["ZETACHAIN_TESTNET"] = 2002] = "ZETACHAIN_TESTNET";
  Network2[Network2["BLAST_MAINNET"] = 2101] = "BLAST_MAINNET";
  Network2[Network2["BLAST_SEPOLIA"] = 2102] = "BLAST_SEPOLIA";
  Network2[Network2["SCROLL_MAINNET"] = 2201] = "SCROLL_MAINNET";
  Network2[Network2["SCROLL_SEPOLIA"] = 2202] = "SCROLL_SEPOLIA";
  Network2[Network2["LINEA_MAINNET"] = 2301] = "LINEA_MAINNET";
  Network2[Network2["LINEA_SEPOLIA"] = 2302] = "LINEA_SEPOLIA";
  Network2[Network2["GNOSIS_MAINNET"] = 2401] = "GNOSIS_MAINNET";
  Network2[Network2["GNOSIS_CHIADO"] = 2402] = "GNOSIS_CHIADO";
  Network2[Network2["FANTOM_MAINNET"] = 2501] = "FANTOM_MAINNET";
  Network2[Network2["FANTOM_TESTNET"] = 2502] = "FANTOM_TESTNET";
  Network2[Network2["MANTLE_MAINNET"] = 2601] = "MANTLE_MAINNET";
  Network2[Network2["MANTLE_SEPOLIA"] = 2602] = "MANTLE_SEPOLIA";
  Network2[Network2["CELO_MAINNET"] = 2701] = "CELO_MAINNET";
  Network2[Network2["CELO_BAKLAVA"] = 2703] = "CELO_BAKLAVA";
  Network2[Network2["BERACHAIN_MAINNET"] = 2803] = "BERACHAIN_MAINNET";
  Network2[Network2["BERACHAIN_ARTIO"] = 2801] = "BERACHAIN_ARTIO";
  Network2[Network2["BERACHAIN_BARTIO"] = 2802] = "BERACHAIN_BARTIO";
  Network2[Network2["BERACHAIN_BEPOLIA"] = 2804] = "BERACHAIN_BEPOLIA";
  Network2[Network2["METIS_MAINNET"] = 2901] = "METIS_MAINNET";
  Network2[Network2["OPBNB_MAINNET"] = 3001] = "OPBNB_MAINNET";
  Network2[Network2["OPBNB_TESTNET"] = 3002] = "OPBNB_TESTNET";
  Network2[Network2["POLYNOMIAL_MAINNET"] = 3101] = "POLYNOMIAL_MAINNET";
  Network2[Network2["POLYNOMIAL_SEPOLIA"] = 3102] = "POLYNOMIAL_SEPOLIA";
  Network2[Network2["SHAPE_MAINNET"] = 3201] = "SHAPE_MAINNET";
  Network2[Network2["SHAPE_SEPOLIA"] = 3202] = "SHAPE_SEPOLIA";
  Network2[Network2["BOB_MAINNET"] = 3301] = "BOB_MAINNET";
  Network2[Network2["BOB_SEPOLIA"] = 3302] = "BOB_SEPOLIA";
  Network2[Network2["CROSSFI_TESTNET"] = 3401] = "CROSSFI_TESTNET";
  Network2[Network2["CROSSFI_MAINNET"] = 3402] = "CROSSFI_MAINNET";
  Network2[Network2["IOTA_MAINNET"] = 3501] = "IOTA_MAINNET";
  Network2[Network2["IOTA_TESTNET"] = 3502] = "IOTA_TESTNET";
  Network2[Network2["MODE_MAINNET"] = 3601] = "MODE_MAINNET";
  Network2[Network2["MODE_SEPOLIA"] = 3602] = "MODE_SEPOLIA";
  Network2[Network2["MOONBASE_ALPHA"] = 3701] = "MOONBASE_ALPHA";
  Network2[Network2["MOONBEAM_MAINNET"] = 3801] = "MOONBEAM_MAINNET";
  Network2[Network2["MOONRIVER_MAINNET"] = 3901] = "MOONRIVER_MAINNET";
  Network2[Network2["PALM_MAINNET"] = 4001] = "PALM_MAINNET";
  Network2[Network2["PALM_TESTNET"] = 4002] = "PALM_TESTNET";
  Network2[Network2["SHIDEN_MAINNET"] = 4101] = "SHIDEN_MAINNET";
  Network2[Network2["SHIDEN_SHIBUYA"] = 4102] = "SHIDEN_SHIBUYA";
  Network2[Network2["SEI_MAINNET"] = 4201] = "SEI_MAINNET";
  Network2[Network2["SEI_TESTNET"] = 4202] = "SEI_TESTNET";
  Network2[Network2["KINTO_MAINNET"] = 4301] = "KINTO_MAINNET";
  Network2[Network2["PLUME_TESTNET"] = 4402] = "PLUME_TESTNET";
  Network2[Network2["ANIME_MAINNET"] = 4501] = "ANIME_MAINNET";
  Network2[Network2["ANIME_SEPOLIA"] = 4502] = "ANIME_SEPOLIA";
  Network2[Network2["RACE_MAINNET"] = 4601] = "RACE_MAINNET";
  Network2[Network2["RACE_SEPOLIA"] = 4602] = "RACE_SEPOLIA";
  Network2[Network2["APECHAIN_MAINNET"] = 4701] = "APECHAIN_MAINNET";
  Network2[Network2["APECHAIN_CURTIS"] = 4702] = "APECHAIN_CURTIS";
  Network2[Network2["APEX_MAINNET"] = 4801] = "APEX_MAINNET";
  Network2[Network2["BOSS_MAINNET"] = 4901] = "BOSS_MAINNET";
  Network2[Network2["LENS_MAINNET"] = 5001] = "LENS_MAINNET";
  Network2[Network2["LENS_SEPOLIA"] = 5002] = "LENS_SEPOLIA";
  Network2[Network2["SONEIUM_MAINNET"] = 5101] = "SONEIUM_MAINNET";
  Network2[Network2["SONEIUM_MINATO"] = 5102] = "SONEIUM_MINATO";
  Network2[Network2["GEIST_MAINNET"] = 5201] = "GEIST_MAINNET";
  Network2[Network2["GEIST_POLTER"] = 5202] = "GEIST_POLTER";
  Network2[Network2["SOCIALNETWORK_TESTNET"] = 5301] = "SOCIALNETWORK_TESTNET";
  Network2[Network2["SOCIALNETWORK_MAINNET"] = 5302] = "SOCIALNETWORK_MAINNET";
  Network2[Network2["ALCHEMYARB_FAM"] = 5501] = "ALCHEMYARB_FAM";
  Network2[Network2["ALCHEMYARB_SEPOLIA"] = 5502] = "ALCHEMYARB_SEPOLIA";
  Network2[Network2["ROOTSTOCK_MAINNET"] = 5601] = "ROOTSTOCK_MAINNET";
  Network2[Network2["ROOTSTOCK_TESTNET"] = 5602] = "ROOTSTOCK_TESTNET";
  Network2[Network2["LUMIA_PRISM"] = 5701] = "LUMIA_PRISM";
  Network2[Network2["LUMIA_TESTNET"] = 5702] = "LUMIA_TESTNET";
  Network2[Network2["UNICHAIN_MAINNET"] = 5801] = "UNICHAIN_MAINNET";
  Network2[Network2["UNICHAIN_SEPOLIA"] = 5802] = "UNICHAIN_SEPOLIA";
  Network2[Network2["SONIC_MAINNET"] = 5901] = "SONIC_MAINNET";
  Network2[Network2["SONIC_TESTNET"] = 5902] = "SONIC_TESTNET";
  Network2[Network2["SONIC_BLAZE"] = 5903] = "SONIC_BLAZE";
  Network2[Network2["SPOTLIGHT_SEPOLIA"] = 6001] = "SPOTLIGHT_SEPOLIA";
  Network2[Network2["SPOTLIGHT_MAINNET"] = 6002] = "SPOTLIGHT_MAINNET";
  Network2[Network2["XMTP_TESTNET"] = 6101] = "XMTP_TESTNET";
  Network2[Network2["CHILIZ_MAINNET"] = 6201] = "CHILIZ_MAINNET";
  Network2[Network2["CHILIZ_SPICY"] = 6202] = "CHILIZ_SPICY";
  Network2[Network2["ABSTRACT_MAINNET"] = 6301] = "ABSTRACT_MAINNET";
  Network2[Network2["ABSTRACT_TESTNET"] = 6302] = "ABSTRACT_TESTNET";
  Network2[Network2["K2_TESTNET"] = 6401] = "K2_TESTNET";
  Network2[Network2["METABASED_STRATOS"] = 6501] = "METABASED_STRATOS";
  Network2[Network2["MONAD_TESTNET"] = 6602] = "MONAD_TESTNET";
  Network2[Network2["MONAD_MAINNET"] = 6603] = "MONAD_MAINNET";
  Network2[Network2["SUPERSEED_MAINNET"] = 6701] = "SUPERSEED_MAINNET";
  Network2[Network2["SUPERSEED_SEPOLIA"] = 6702] = "SUPERSEED_SEPOLIA";
  Network2[Network2["DEGEN_MAINNET"] = 6801] = "DEGEN_MAINNET";
  Network2[Network2["DEGEN_SEPOLIA"] = 6802] = "DEGEN_SEPOLIA";
  Network2[Network2["UNITE_MAINNET"] = 6901] = "UNITE_MAINNET";
  Network2[Network2["UNITE_TESTNET"] = 6902] = "UNITE_TESTNET";
  Network2[Network2["SETTLUS_MAINNET"] = 7001] = "SETTLUS_MAINNET";
  Network2[Network2["SETTLUS_SEPTESTNET"] = 7002] = "SETTLUS_SEPTESTNET";
  Network2[Network2["INK_MAINNET"] = 7101] = "INK_MAINNET";
  Network2[Network2["INK_SEPOLIA"] = 7102] = "INK_SEPOLIA";
  Network2[Network2["ODYSSEY_SEPOLIA"] = 7201] = "ODYSSEY_SEPOLIA";
  Network2[Network2["RONIN_MAINNET"] = 7301] = "RONIN_MAINNET";
  Network2[Network2["RONIN_SAIGON"] = 7302] = "RONIN_SAIGON";
  Network2[Network2["STANDARD_MAINNET"] = 7401] = "STANDARD_MAINNET";
  Network2[Network2["STANDARD_TESTNET"] = 7402] = "STANDARD_TESTNET";
  Network2[Network2["SYNDICATE_EXO"] = 7601] = "SYNDICATE_EXO";
  Network2[Network2["HUMANITY_MAINNET"] = 7701] = "HUMANITY_MAINNET";
  Network2[Network2["HUMANITY_TESTNET"] = 7702] = "HUMANITY_TESTNET";
  Network2[Network2["XPROTOCOL_MAINNET"] = 7801] = "XPROTOCOL_MAINNET";
  Network2[Network2["XPROTOCOL_SEPOLIA"] = 7802] = "XPROTOCOL_SEPOLIA";
  Network2[Network2["SPARKPOINT_MAINNET"] = 7901] = "SPARKPOINT_MAINNET";
  Network2[Network2["SPARKPOINT_TESTNET"] = 7902] = "SPARKPOINT_TESTNET";
  Network2[Network2["ALTERSCOPE_MAINNET"] = 8001] = "ALTERSCOPE_MAINNET";
  Network2[Network2["ALTERSCOPE_SEPOLIA"] = 8002] = "ALTERSCOPE_SEPOLIA";
  Network2[Network2["GENSYN_TESTNET"] = 8201] = "GENSYN_TESTNET";
  Network2[Network2["TEA_MAINNET"] = 8101] = "TEA_MAINNET";
  Network2[Network2["TEA_SEPOLIA"] = 8102] = "TEA_SEPOLIA";
  Network2[Network2["OPENLOOT_SEPOLIA"] = 8301] = "OPENLOOT_SEPOLIA";
  Network2[Network2["RISE_TESTNET"] = 8402] = "RISE_TESTNET";
  Network2[Network2["BITCOIN_MAINNET"] = 8501] = "BITCOIN_MAINNET";
  Network2[Network2["BITCOIN_TESTNET"] = 8502] = "BITCOIN_TESTNET";
  Network2[Network2["BITCOIN_SIGNET"] = 8503] = "BITCOIN_SIGNET";
  Network2[Network2["MARS_TESTNET"] = 8601] = "MARS_TESTNET";
  Network2[Network2["EARNM_SEPOLIA"] = 8701] = "EARNM_SEPOLIA";
  Network2[Network2["STORY_MAINNET"] = 8801] = "STORY_MAINNET";
  Network2[Network2["STORY_AENEID"] = 8802] = "STORY_AENEID";
  Network2[Network2["WYLERCHAIN_SEPOLIA"] = 8901] = "WYLERCHAIN_SEPOLIA";
  Network2[Network2["MEGAETH_MAINNET"] = 9001] = "MEGAETH_MAINNET";
  Network2[Network2["MEGAETH_TESTNET"] = 9002] = "MEGAETH_TESTNET";
  Network2[Network2["APTOS_MAINNET"] = 9101] = "APTOS_MAINNET";
  Network2[Network2["APTOS_TESTNET"] = 9102] = "APTOS_TESTNET";
  Network2[Network2["SUI_MAINNET"] = 9201] = "SUI_MAINNET";
  Network2[Network2["SUI_TESTNET"] = 9202] = "SUI_TESTNET";
  Network2[Network2["WORLDMOBILE_DEVNET"] = 9302] = "WORLDMOBILE_DEVNET";
  Network2[Network2["CONVERGE_TESTNET"] = 9402] = "CONVERGE_TESTNET";
  Network2[Network2["HYPERLIQUID_MAINNET"] = 9901] = "HYPERLIQUID_MAINNET";
  Network2[Network2["HYPERLIQUID_TESTNET"] = 9902] = "HYPERLIQUID_TESTNET";
  Network2[Network2["V_DEVNET"] = 1073] = "V_DEVNET";
  Network2[Network2["PLASMA_MAINNET"] = 11001] = "PLASMA_MAINNET";
  Network2[Network2["CELO_SEPOLIA"] = 2704] = "CELO_SEPOLIA";
  return Network2;
}({});
const NETWORK_IDS = new Set(Object.keys(Network).filter((key) => isNaN(Number(key))));
var Availability = /* @__PURE__ */ function(Availability2) {
  Availability2["PRERELEASE"] = "prerelease";
  Availability2["PUBLIC"] = "public";
  Availability2["DEPRECATED"] = "deprecated";
  return Availability2;
}({});
const NetworkIdSchema = z.string().transform((v) => v);
const NON_STANDARD_NETWORK_IDS = {
  ARBMAINNET: "ARB_MAINNET",
  ARBSEPOLIA: "ARB_SEPOLIA",
  BASEMAINNET: "BASE_MAINNET",
  BASESEPOLIA: "BASE_SEPOLIA",
  BERACHAIN_BARTIO: "BERACHAIN_BARTIO",
  HOLESKY: "ETH_HOLESKY",
  MAINNET: "ETH_MAINNET",
  SEPOLIA: "ETH_SEPOLIA",
  HOODI: "ETH_HOODI",
  MATICAMOY: "MATIC_AMOY",
  MATICMAINNET: "MATIC_MAINNET",
  OPTMAINNET: "OPT_MAINNET",
  OPTIMISM_MAINNET: "OPT_MAINNET",
  OPTSEPOLIA: "OPT_SEPOLIA",
  OPTIMISM_SEPOLIA: "OPT_SEPOLIA",
  SOLDEVNET: "SOLANA_DEVNET",
  SOLMAINNET: "SOLANA_MAINNET",
  WORLDCHAINMAINNET: "WORLDCHAIN_MAINNET",
  WORLDCHAINSEPOLIA: "WORLDCHAIN_SEPOLIA",
  ZKSYNCMAINNET: "ZKSYNC_MAINNET",
  ZKSYNCSEPOLIA: "ZKSYNC_SEPOLIA"
};
export {
  Availability,
  NETWORK_IDS,
  NON_STANDARD_NETWORK_IDS,
  Network,
  NetworkIdSchema
};
//# sourceMappingURL=network.js.map